import { useEffect, useState } from "react";
import { CardDetails } from "../../../../common/components/CardDetails/CardDetails"
import style from "./style.module.scss"
import {  ContainerService } from "../../../../common/services/merchandise_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../common/components/Loader/Loader";
import { useLocation } from "react-router";
import { useOperationType } from "../../../operations/core/_context";

type storageContainerDetailType = {
  initialValue: any
}

const StorageContainerDetail = ( {initialValue}: storageContainerDetailType) => {

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>({});

  const id = initialValue?.["@id"].split("/").pop();

  const operationType = useOperationType();

  useEffect(() => {
    id && getStorageContainer(id);
  }, [initialValue]);

  const getStorageContainer = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await ContainerService.getContainerById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setData(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

const renderValue = (value : any /* string | number | boolean */) => {
  return value ? value : "-";
};

const sealNumbers =
    data?.additionalSealNumbersCount > 0
      ? `${renderValue(data?.sealNumber)}, ${data?.additionalSealNumbersAsString}`
      : renderValue(data?.sealNumber);

  return (
    <div>
      <Loader isLoading={isLoading}/>
      <CardDetails className="d-flex gap-2 flex-column">
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Référence : </span>
                <span className={style.details__value}>{renderValue(data?.reference)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Type : </span>
                <span className={style.details__value}>{renderValue(data?.containerType?.containerCategory?.name)} - {renderValue(data?.containerType?.containerUnit?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Code type : </span>
                <span className={style.details__value}>{renderValue(data?.containerType?.abbreviation)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Type de chargement : </span>
                <span className={style.details__value}>{renderValue(data?.loadType?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>État de remplissage : </span>
                <span className={style.details__value}>{renderValue(data?.loadFillingStatus?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>État : </span>
                <span className={style.details__value}>{renderValue(data?.loadState?.name)}</span>
              </div>
              {operationType === "sales" && (
                <div className={style.details__item}>
                  <span className={style.details__subtitle}>Numéro BL : </span>
                  <span className={style.details__value}>{renderValue(data?.blNumber)}</span>
              </div>
              )}
              <div className={style.details__item}>
                <span className={style.details__subtitle}>N° Plomb  : </span>
                <span className={style.details__value}>{sealNumbers}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Tonnage : </span>
                <span className={style.details__value}>{renderValue(data?.tonnage)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Poids net : </span>
                <span className={style.details__value}>{renderValue(data?.netWeight)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Tare : </span>
                <span className={style.details__value}>{renderValue(data?.tareWeight)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Quantité : </span>
                <span className={style.details__value}>{renderValue(data?.qty)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Importé : </span>
                <span className={style.details__value}>{renderValue(data?.imported)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Contrôlé : </span>
                <span className={style.details__value}>{renderValue(data?.controlled)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Mouvement : </span>
                <span className={style.details__value}>{renderValue(data?.movementTypeTxt)}</span>
              </div>
            </CardDetails>
    </div>
  )
}

export default StorageContainerDetail